<script>
import { EventCardElementMixin } from "%/dynamic-component-editor/standard-components/event-card/event-card-element-mixin";
import TextElement
  from "%/dynamic-component-editor/standard-elements/text-element/TextElement.vue";
import BrandedTextStyleOptions from "%/dynamic-component-editor/bundles/branded-text-style-options";
import { formatEventDuration } from "%/dynamic-component-editor/helpers/event-duration";

export default {
  name: "EventDuration",
  elementPanelSettings: {
    displayIcon: "hugeicons:time-03",
    elementGroup: "eventElements",
    elementType: "element",
    displayName: "Event Duration",
  },
  extends: TextElement,
  mixins: [EventCardElementMixin],
  optionBundles: [
    new BrandedTextStyleOptions({}, {
      "text-option": true,
    }),
  ],
  computed: {
    isEditable() {
      return false;
    },
    value() {
      return formatEventDuration(this.entity.startTime, this.entity.endTime);
    },
  },
};
</script>
